<template>
  <layout>
      <span slot="header">{{ modelTitle }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
      <div slot="content">
          <div class="pop-content-search">
              <el-form size="mini" label-width="120px" style="margin-left: -55px;" v-if="data.modelCd">
                  <el-row v-for="(item, idx) in items" :key="idx">
                      <el-col :span="12">
                        <el-form-item :label="item.title1">
                              <el-row>
                                  <el-col :span="24">
                                      <p contenteditable style="background-color: white; border-radius: 8px; border: solid 1px; border-color: #babfc7;">{{ item.title1Val }}</p>
                                  </el-col>
                              </el-row>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item :label="item.title2">
                              <el-row>
                                  <el-col :span="24">
                                    <p contenteditable style="background-color: white; border-radius: 8px; border: solid 1px; border-color: #babfc7;">{{ item.title2Val }}</p>
                                  </el-col>
                              </el-row>
                          </el-form-item>
                      </el-col>
                  </el-row>
              </el-form>
              <el-form v-else>
                  <el-row>
                      <el-col>
                        선택된 모델이 없습니다.
                      </el-col>
                  </el-row>
              </el-form>
          </div>
      </div>
  </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
/**
* * components
*/
import {AgGridVue} from 'ag-grid-vue';


export default {
  components: {Layout, AgGridVue},
  props: {
      data: {
          type: Object,
          required: false
      }
  },
  data() {
      return {
        items: [],
        form: {
              
        },
        modelTitle: ''
      }
  },
  mounted() {
    if(this.data.modelCd){
        this.modelTitle = '모델조회(' + this.data.modelCd + ')';
        this.selectModelSpec();
    } else {
        this.modelTitle = '모델조회';
    }
    
    console.log('this.data: ', this.data);
  },
  methods: {
      closeModal() {
          this.$parent.close();
      },
      async selectModelSpec(){
          
          const vform ={
            modelGroup : this.data.modelGroup,
            modelCd : this.data.modelCd
          }

          let vAllObj = [];
                
          this.$store.commit('loading');
          console.log('goOpen vform : ', vform);
          await this.$http.post(("/api/asMng/call/selectModelSpec"), vform
              ).then(response => {
              console.log('pop : ' ,  response.data);
              
              if(response.data && response.data.length >0 && response.data[0].existYn==='N'){
                const vItems = response.data.map((x, index)=>{
                    vAllObj.push({title1: '제조사', title1Val: x.maker, title2: '제품군', title2Val: x.modelGroupNm});
                    vAllObj.push({title1: '대표모델', title1Val: x.standardModelNm, title2: '모델코드', title2Val: x.modelCd});
                    vAllObj.push({title1: '모델명', title1Val: x.modelNm, title2: '', title2Val: ''});
                });
                // maker, '' standardModelNm, 0 guaranteeMonth,
              
              } else if(response.data && response.data.length>0){

                const vItems = response.data.map((x, index)=>{
                  if (index == 0){
                    vAllObj.push({title1: x.modelSpec01, title2: x.modelSpec02});
                    vAllObj.push({title1: x.modelSpec03, title2: x.modelSpec04});
                    vAllObj.push({title1: x.modelSpec05, title2: x.modelSpec06});
                    vAllObj.push({title1: x.modelSpec07, title2: x.modelSpec08});
                    vAllObj.push({title1: x.modelSpec09, title2: x.modelSpec10});
                    vAllObj.push({title1: x.modelSpec11, title2: x.modelSpec12});
                    vAllObj.push({title1: x.modelSpec13, title2: x.modelSpec14});
                    vAllObj.push({title1: x.modelSpec15, title2: x.modelSpec16});
                    vAllObj.push({title1: x.modelSpec17, title2: x.modelSpec18});
                    vAllObj.push({title1: x.modelSpec19, title2: x.modelSpec20});
                    vAllObj.push({title1: x.modelSpec21, title2: x.modelSpec22});
                    vAllObj.push({title1: x.modelSpec23, title2: x.modelSpec24});
                    vAllObj.push({title1: x.modelSpec25, title2: x.modelSpec26});
                    vAllObj.push({title1: x.modelSpec27, title2: x.modelSpec28});
                    vAllObj.push({title1: x.modelSpec29, title2: x.modelSpec30});
                    vAllObj.push({title1: x.modelSpec31, title2: x.modelSpec32});
                    vAllObj.push({title1: x.modelSpec33, title2: x.modelSpec34});
                    vAllObj.push({title1: x.modelSpec35, title2: x.modelSpec36});
                    vAllObj.push({title1: x.modelSpec37, title2: x.modelSpec38});
                    vAllObj.push({title1: x.modelSpec39, title2: x.modelSpec40});
                    vAllObj.push({title1: x.modelSpec41, title2: x.modelSpec42});
                    vAllObj.push({title1: x.modelSpec43, title2: x.modelSpec44});
                    vAllObj.push({title1: x.modelSpec45, title2: x.modelSpec46});
                    vAllObj.push({title1: x.modelSpec47, title2: x.modelSpec48});
                    vAllObj.push({title1: x.modelSpec49, title2: x.modelSpec50});

                  } else {
                    vAllObj[0].title1Val = x.modelSpec01 || ''; vAllObj[0].title2Val = x.modelSpec02 || '';
                    vAllObj[1].title1Val = x.standardModelNm || ''; vAllObj[1].title2Val = x.modelSpec04 || '';
                    vAllObj[2].title1Val = x.modelSpec05 || ''; vAllObj[2].title2Val = x.modelSpec06 || '';
                    vAllObj[3].title1Val = x.modelSpec07 || ''; vAllObj[3].title2Val = x.modelSpec08 || '';
                    vAllObj[4].title1Val = x.modelSpec09 || ''; vAllObj[4].title2Val = x.modelSpec10 || '';
                    vAllObj[5].title1Val = x.modelSpec11 || ''; vAllObj[5].title2Val = x.modelSpec12 || '';
                    vAllObj[6].title1Val = x.modelSpec13 || ''; vAllObj[6].title2Val = x.modelSpec14 || '';
                    vAllObj[7].title1Val = x.modelSpec15 || ''; vAllObj[7].title2Val = x.modelSpec16 || '';
                    vAllObj[8].title1Val = x.modelSpec17 || ''; vAllObj[8].title2Val = x.modelSpec18 || '';
                    vAllObj[9].title1Val = x.modelSpec19 || ''; vAllObj[9].title2Val = x.modelSpec20 || '';
                    vAllObj[10].title1Val = x.modelSpec21 || ''; vAllObj[10].title2Val = x.modelSpec22 || '';
                    vAllObj[11].title1Val = x.modelSpec23 || ''; vAllObj[11].title2Val = x.modelSpec24 || '';
                    vAllObj[12].title1Val = x.modelSpec25 || ''; vAllObj[12].title2Val = x.modelSpec26 || '';
                    vAllObj[13].title1Val = x.modelSpec27 || ''; vAllObj[13].title2Val = x.modelSpec28 || '';
                    vAllObj[14].title1Val = x.modelSpec29 || ''; vAllObj[14].title2Val = x.modelSpec30 || '';
                    vAllObj[15].title1Val = x.modelSpec31 || ''; vAllObj[15].title2Val = x.modelSpec32 || '';
                    vAllObj[16].title1Val = x.modelSpec33 || ''; vAllObj[16].title2Val = x.modelSpec34 || '';
                    vAllObj[17].title1Val = x.modelSpec35 || ''; vAllObj[17].title2Val = x.modelSpec36 || '';
                    vAllObj[18].title1Val = x.modelSpec37 || ''; vAllObj[18].title2Val = x.modelSpec38 || '';
                    vAllObj[19].title1Val = x.modelSpec39 || ''; vAllObj[19].title2Val = x.modelSpec40 || '';
                    vAllObj[20].title1Val = x.modelSpec41 || ''; vAllObj[20].title2Val = x.modelSpec42 || '';
                    vAllObj[21].title1Val = x.modelSpec43 || ''; vAllObj[21].title2Val = x.modelSpec44 || '';
                    vAllObj[22].title1Val = x.modelSpec45 || ''; vAllObj[22].title2Val = x.modelSpec46 || '';
                    vAllObj[23].title1Val = x.modelSpec47 || ''; vAllObj[23].title2Val = x.modelSpec48 || '';
                    vAllObj[24].title1Val = x.modelSpec49 || ''; vAllObj[24].title2Val = x.modelSpec50 || '';
                    
                  }
                  
                  
                });
              }

              console.log('====vAllObj : ', vAllObj);
              this.items = _.cloneDeep(vAllObj) || [];

          }).finally(() => {
              this.$store.commit('finish');
          });

      }
  }
}
</script>

<style lang="scss" scoped>
.el-sub-form {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 0px 10px 0px;
  border-radius: 5px; 
  margin-left: 0px;
  .el-form-item {
      margin-left: -35px;
      margin-right: 15px;
  }
}
</style>